/**
 * Returns the landing route for a user based on their role.
 * External clients land on the PM home; internal users on the dashboard.
 */
export const roleHome = (user) => {
  if (user && user.role === 'client') {
    return '/pm';
  }
  return '/dashboard';
};

export default roleHome;
